var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "USDT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-692",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.801 20C39.801 30.9908 30.8913 39.9005 19.9005 39.9005C8.90965 39.9005 0 30.9908 0 20C0 9.00914 8.90965 0.0994873 19.9005 0.0994873C30.8913 0.0994873 39.801 9.00914 39.801 20Z",
    fill: "#1BA27A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-694",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2402 10.1345H10.3962V14.6835H17.5437V21.3701H22.0928V14.6835H29.2402V10.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-696",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8617 22.0826C13.949 22.0826 9.1558 21.1469 9.1558 19.9925C9.1558 18.8383 13.949 17.9023 19.8617 17.9023C25.7741 17.9023 30.5673 18.8383 30.5673 19.9925C30.5673 21.1469 25.7741 22.0826 19.8617 22.0826ZM31.8826 20.341C31.8826 18.8524 26.5007 17.6456 19.8617 17.6456C13.2227 17.6456 7.84058 18.8524 7.84058 20.341C7.84058 21.6516 12.0139 22.7437 17.5439 22.9859V32.5847H22.0929V22.9897C27.6657 22.7551 31.8826 21.6586 31.8826 20.341Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtm);
export default __webpack_public_path__ + "static/media/ttm.81d48af0777525b0d01ace2c80c7c904.svg";
export { ForwardRef as ReactComponent };